module.exports = __webpack_public_path__ + "img/logo2.76ed9d67.png";